module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card_open_container"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "appear": ""
    }
  }, [(!_vm.card.fields.image) ? [_c('div', {
    staticClass: "card_open no_image",
    class: _vm._f("lower_case")(_vm.card.fields.cardType)
  }, [_c('svg', {
    staticClass: "card_close",
    attrs: {
      "width": "29",
      "height": "29",
      "viewBox": "0 0 29 29",
      "xmlns": "http://www.w3.org/2000/svg"
    },
    on: {
      "click": function($event) {
        _vm.navigate('desktop')
      }
    }
  }, [_c('title', [_vm._v("Group 4")]), _c('g', {
    attrs: {
      "stroke": "#FFF",
      "stroke-width": "3",
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2.46 1.64l24.917 24.915M27.377 1.64L2.46 26.554"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "card_number"
  }, [_vm._v(_vm._s(_vm._f("card_number")(_vm.card.fields.cardNumber)))]), _vm._v(" "), _c('div', {
    staticClass: "card_content"
  }, [_c('p', {
    staticClass: "card_title"
  }, [_vm._v(_vm._s(_vm.card.fields.cardTitle))]), _vm._v(" "), (_vm.card.fields.sponsored) ? _c('p', {
    staticClass: "card_sponsored"
  }, [_vm._v("presented by toyota c-hr")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "card_description"
  }, [_vm._v(_vm._s(_vm.card.fields.cardFullDescription))]), _vm._v(" "), _c('div', {
    staticClass: "card_buttons"
  }, [_c('div', {
    staticClass: "bttn_default bttn_share"
  }, [_vm._v("\n                                share\n                                "), _c('div', {
    staticClass: "social_icons"
  }, [_c('i', {
    staticClass: "fa fa-facebook",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.facebook
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "mail_link",
    attrs: {
      "href": 'mailto:?subject=100%20Days%20of%20Summer&body=http://refinery29.com/things-to-do-summer-2017/#/' + _vm.card.fields.cardNumber
    },
    on: {
      "click": _vm.email
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "link_icon",
    attrs: {
      "data-clipboard-text": 'http://refinery29.com/things-to-do-summer-2017/#/' + _vm.card.fields.cardNumber
    },
    on: {
      "click": _vm.clipboard_click
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/link.svg")
    }
  })])])]), _vm._v(" "), (_vm.card.fields.cardType == 'Do') ? _c('a', {
    staticClass: "bttn_default",
    attrs: {
      "href": _vm.card.fields.clickOutUrl,
      "target": "_blank"
    },
    on: {
      "click": _vm.card_link_ga
    }
  }, [_vm._v(_vm._s(_vm.card.fields.cardType))]) : (_vm.card.fields.cardType == 'Listen') ? _c('a', {
    staticClass: "bttn_default",
    attrs: {
      "href": _vm.card.fields.clickOutUrl,
      "target": "_blank"
    },
    on: {
      "click": _vm.card_link_ga
    }
  }, [_vm._v(_vm._s(_vm.card.fields.cardType))]) : (_vm.card.fields.cardType == 'Make') ? _c('a', {
    staticClass: "bttn_default",
    attrs: {
      "href": _vm.card.fields.clickOutUrl,
      "target": "_blank"
    },
    on: {
      "click": _vm.card_link_ga
    }
  }, [_vm._v(_vm._s(_vm.card.fields.cardType))]) : (_vm.card.fields.cardType == 'Buy') ? _c('a', {
    staticClass: "bttn_default",
    attrs: {
      "href": _vm.card.fields.clickOutUrl,
      "target": "_blank"
    },
    on: {
      "click": _vm.card_link_ga
    }
  }, [_vm._v(_vm._s(_vm.card.fields.cardType))]) : _c('a', {
    staticClass: "bttn_default",
    attrs: {
      "href": _vm.card.fields.clickOutUrl,
      "target": "_blank"
    },
    on: {
      "click": _vm.card_link_ga
    }
  }, [_vm._v("watch")])])]), _vm._v(" "), (_vm.card.fields.cardType == 'Do') ? _c('img', {
    staticClass: "card_icon",
    attrs: {
      "src": require("../assets/img/do.svg")
    }
  }) : (_vm.card.fields.cardType == 'Listen') ? _c('img', {
    staticClass: "card_icon",
    attrs: {
      "src": require("../assets/img/listen.svg")
    }
  }) : (_vm.card.fields.cardType == 'Make') ? _c('img', {
    staticClass: "card_icon",
    attrs: {
      "src": require("../assets/img/make.svg")
    }
  }) : (_vm.card.fields.cardType == 'Buy') ? _c('img', {
    staticClass: "card_icon",
    attrs: {
      "src": require("../assets/img/buy.svg")
    }
  }) : _c('img', {
    staticClass: "card_icon",
    attrs: {
      "src": require("../assets/img/watch.svg")
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.card && _vm.card.fields.image) ? [_c('div', {
    staticClass: "card_open has_image",
    class: _vm.card.fields.cardType.toLowerCase()
  }, [_c('div', {
    staticClass: "card_open_image",
    style: ({
      'background-image': 'url(' + _vm.card.fields.image + ')'
    })
  }), _vm._v(" "), (_vm.card.fields.disclaimer) ? _c('p', {
    staticClass: "card_sponsored disclaimer"
  }, [_vm._v(_vm._s(_vm.card.fields.disclaimer))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card_open_content"
  }, [_c('svg', {
    staticClass: "card_close",
    attrs: {
      "width": "29",
      "height": "29",
      "viewBox": "0 0 29 29",
      "xmlns": "http://www.w3.org/2000/svg"
    },
    on: {
      "click": function($event) {
        _vm.navigate('desktop')
      }
    }
  }, [_c('title', [_vm._v("Group 4")]), _c('g', {
    attrs: {
      "stroke": "#FFF",
      "stroke-width": "3",
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2.46 1.64l24.917 24.915M27.377 1.64L2.46 26.554"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "card_number"
  }, [_vm._v(_vm._s(_vm._f("card_number")(_vm.card.fields.cardNumber)))]), _vm._v(" "), _c('div', {
    staticClass: "card_content"
  }, [_c('p', {
    staticClass: "card_title"
  }, [_vm._v(_vm._s(_vm.card.fields.cardTitle))]), _vm._v(" "), (_vm.card.fields.sponsored) ? _c('p', {
    staticClass: "card_sponsored"
  }, [_vm._v("presented by toyota c-hr")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "card_description"
  }, [_vm._v(_vm._s(_vm.card.fields.cardFullDescription))]), _vm._v(" "), _c('div', {
    staticClass: "card_buttons"
  }, [_c('div', {
    staticClass: "bttn_default bttn_share"
  }, [_vm._v("\n\t                                share\n\t                                "), _c('div', {
    staticClass: "social_icons"
  }, [_c('i', {
    staticClass: "fa fa-facebook",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.facebook
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "mail_link",
    attrs: {
      "href": 'mailto:?subject=100%20Days%20of%20Summer&body=http://refinery29.com/things-to-do-summer-2017/#/' + _vm.card.fields.cardNumber
    },
    on: {
      "click": _vm.email
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "link_icon",
    attrs: {
      "data-clipboard-text": 'http://refinery29.com/things-to-do-summer-2017/#/' + _vm.card.fields.cardNumber
    },
    on: {
      "click": _vm.clipboard_click
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/link.svg")
    }
  })])])]), _vm._v(" "), (_vm.card.fields.cardType == 'Do') ? _c('a', {
    staticClass: "bttn_default",
    attrs: {
      "href": _vm.card.fields.clickOutUrl,
      "target": "_blank"
    },
    on: {
      "click": _vm.card_link_ga
    }
  }, [_vm._v(_vm._s(_vm.card.fields.cardType))]) : (_vm.card.fields.cardType == 'Listen') ? _c('a', {
    staticClass: "bttn_default",
    attrs: {
      "href": _vm.card.fields.clickOutUrl,
      "target": "_blank"
    },
    on: {
      "click": _vm.card_link_ga
    }
  }, [_vm._v(_vm._s(_vm.card.fields.cardType))]) : (_vm.card.fields.cardType == 'Make') ? _c('a', {
    staticClass: "bttn_default",
    attrs: {
      "href": _vm.card.fields.clickOutUrl,
      "target": "_blank"
    },
    on: {
      "click": _vm.card_link_ga
    }
  }, [_vm._v(_vm._s(_vm.card.fields.cardType))]) : (_vm.card.fields.cardType == 'Buy') ? _c('a', {
    staticClass: "bttn_default",
    attrs: {
      "href": _vm.card.fields.clickOutUrl,
      "target": "_blank"
    },
    on: {
      "click": _vm.card_link_ga
    }
  }, [_vm._v(_vm._s(_vm.card.fields.cardType))]) : _c('a', {
    staticClass: "bttn_default",
    attrs: {
      "href": _vm.card.fields.clickOutUrl,
      "target": "_blank"
    },
    on: {
      "click": _vm.card_link_ga
    }
  }, [_vm._v("watch")])])]), _vm._v(" "), (_vm.card.fields.cardType == 'Do') ? _c('img', {
    staticClass: "card_icon",
    attrs: {
      "src": require("../assets/img/do.svg")
    }
  }) : (_vm.card.fields.cardType == 'Listen') ? _c('img', {
    staticClass: "card_icon",
    attrs: {
      "src": require("../assets/img/listen.svg")
    }
  }) : (_vm.card.fields.cardType == 'Make') ? _c('img', {
    staticClass: "card_icon",
    attrs: {
      "src": require("../assets/img/make.svg")
    }
  }) : (_vm.card.fields.cardType == 'Buy') ? _c('img', {
    staticClass: "card_icon",
    attrs: {
      "src": require("../assets/img/buy.svg")
    }
  }) : _c('img', {
    staticClass: "card_icon",
    attrs: {
      "src": require("../assets/img/watch.svg")
    }
  })])])] : _vm._e()], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "appear": ""
    },
    on: {
      "appear": _vm.mobile_animation_enter
    }
  }, [
    [_c('div', {
      class: [_vm.card.fields.cardType.toLowerCase(), {
        facebook: _vm.facebook_browser
      }],
      attrs: {
        "id": "card_mobile"
      }
    }, [_c('img', {
      staticClass: "card_close",
      attrs: {
        "src": require("../assets/img/close.svg")
      },
      on: {
        "click": function($event) {
          _vm.navigate('mobile')
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "card_title"
    }, [_vm._v(_vm._s(_vm.card.fields.cardTitle))]), _vm._v(" "), (_vm.card.fields.sponsored) ? _c('p', {
      staticClass: "mobile_card_sponsored"
    }, [_vm._v("presented by toyota c-hr")]) : _vm._e(), _vm._v(" "), (_vm.card.fields.image) ? _c('div', {
      staticClass: "card_mobile_image",
      style: ({
        'background-image': 'url(' + _vm.card.fields.image + ')'
      })
    }) : _vm._e(), _vm._v(" "), (_vm.card.fields.disclaimer) ? _c('p', {
      staticClass: "mobile_card_sponsored disclaimer"
    }, [_vm._v(_vm._s(_vm.card.fields.disclaimer))]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "card_mobile_description"
    }, [_vm._v(_vm._s(_vm.card.fields.cardFullDescription))]), _vm._v(" "), _c('div', {
      staticClass: "card_buttons"
    }, [_c('div', {
      staticClass: "bttn_default bttn_share",
      class: {
        active: _vm.mobile_share_active
      },
      on: {
        "click": _vm.mobile_share_button
      }
    }, [_vm._v("\n                            share\n                            "), _c('div', {
      staticClass: "social_icons"
    }, [_c('i', {
      staticClass: "fa fa-facebook",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": _vm.facebook
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "mail_link",
      attrs: {
        "href": 'mailto:?subject=100%20Days%20of%20Summer&body=http://refinery29.com/things-to-do-summer-2017/#/' + _vm.card.fields.cardNumber
      },
      on: {
        "click": _vm.email
      }
    }, [_c('i', {
      staticClass: "fa fa-envelope-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "link_icon",
      attrs: {
        "data-clipboard-text": 'http://refinery29.com/things-to-do-summer-2017/#/' + _vm.card.fields.cardNumber
      },
      on: {
        "click": _vm.clipboard_click
      }
    }, [_c('img', {
      attrs: {
        "src": require("../assets/img/link.svg")
      }
    })])])]), _vm._v(" "), (_vm.card.fields.cardType == 'Do') ? _c('a', {
      staticClass: "bttn_default",
      attrs: {
        "href": _vm.card.fields.clickOutUrl,
        "target": "_blank"
      },
      on: {
        "click": _vm.card_link_ga
      }
    }, [_vm._v(_vm._s(_vm.card.fields.cardType))]) : (_vm.card.fields.cardType == 'Listen') ? _c('a', {
      staticClass: "bttn_default",
      attrs: {
        "href": _vm.card.fields.clickOutUrl,
        "target": "_blank"
      },
      on: {
        "click": _vm.card_link_ga
      }
    }, [_vm._v(_vm._s(_vm.card.fields.cardType))]) : (_vm.card.fields.cardType == 'Make') ? _c('a', {
      staticClass: "bttn_default",
      attrs: {
        "href": _vm.card.fields.clickOutUrl,
        "target": "_blank"
      },
      on: {
        "click": _vm.card_link_ga
      }
    }, [_vm._v(_vm._s(_vm.card.fields.cardType))]) : (_vm.card.fields.cardType == 'Buy') ? _c('a', {
      staticClass: "bttn_default",
      attrs: {
        "href": _vm.card.fields.clickOutUrl,
        "target": "_blank"
      },
      on: {
        "click": _vm.card_link_ga
      }
    }, [_vm._v(_vm._s(_vm.card.fields.cardType))]) : _c('a', {
      staticClass: "bttn_default",
      attrs: {
        "href": _vm.card.fields.clickOutUrl,
        "target": "_blank"
      },
      on: {
        "click": _vm.card_link_ga
      }
    }, [_vm._v("watch")])]), _vm._v(" "), (_vm.card.fields.cardType == 'Do') ? _c('img', {
      staticClass: "card_icon",
      attrs: {
        "src": require("../assets/img/do.svg")
      }
    }) : (_vm.card.fields.cardType == 'Listen') ? _c('img', {
      staticClass: "card_icon",
      attrs: {
        "src": require("../assets/img/listen.svg")
      }
    }) : (_vm.card.fields.cardType == 'Make') ? _c('img', {
      staticClass: "card_icon",
      attrs: {
        "src": require("../assets/img/make.svg")
      }
    }) : (_vm.card.fields.cardType == 'Buy') ? _c('img', {
      staticClass: "card_icon",
      attrs: {
        "src": require("../assets/img/buy.svg")
      }
    }) : _c('img', {
      staticClass: "card_icon",
      attrs: {
        "src": require("../assets/img/watch.svg")
      }
    })])]
  ], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.clipboard_message),
      expression: "clipboard_message"
    }],
    attrs: {
      "id": "clipboard_message"
    }
  }, [_c('p', [_vm._v("Link has been copied to clipboard")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b1191c1a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/card-open.vue
// module id = 52
// module chunks = 0